import React from 'react';

function Services() {
  // Extracted data so we can loop over it twice for a seamless infinite scroll transition
  const servicesData = [
    {
      title: "Web Development",
      desc: "Next-generation, ultra-performant edge web applications engineered with composable architectures, optimal SEO metrics, and real-time data sync environments."
    },
    {
      title: "Mobile Apps",
      desc: "Cross-platform iOS and Android deployments leveraging native hardware optimization, intuitive spatial fluid layouts, and secure offline-first storage pipelines."
    },
    {
      title: "Cloud Infrastructure",
      desc: "Enterprise serverless cloud ecosystems built across global mesh multi-cloud topologies with fully automated CI/CD configurations and proactive automated security guardrails."
    },
    {
      title: "AI Solutions",
      desc: "Custom large language model (LLM) fine-tuning, cognitive agent workflows, and predictive vector data engines designed to seamlessly automate complex operational tasks."
    }
  ];

  return (
    <div className="presentation-viewport">
      {/* Dynamic Font Awesome and Google Fonts injected cleanly */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" />
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;700&family=Inter:wght@400;500;600&display=swap" rel="stylesheet" />

      {/* Styled Embed block */}
      <style dangerouslySetInnerHTML={{ __html: `
        .presentation-viewport {
          margin: 0;
          padding: 40px 20px;
          box-sizing: border-box;
          background-color: #0b0f19;
          color: #f8fafc;
          font-family: 'Inter', sans-serif;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
        }

        /* RESPONSIVE BASE CONTAINER FRAME - ACTS AS VIEWPORT WINDOW */
        .slides-frame {
          width: 100%;
          max-width: 100%;
          height: 980px;
          background-color: #ffffff;
          color: #0f172a;
          border-radius: 16px;
          box-shadow: 0 25px 60px -15px rgba(0, 0, 0, 0.6);
          position: relative;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px;
          box-sizing: border-box;
        }

        /* HARDWARE-ACCELERATED SLIDING TRACK */
        .slides-track {
          display: flex;
          width: 800%; /* 8 slides * 100% each */
          height: 100%;
          transition: transform 0.65s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .slide-wrapper {
          width: 12.5% !important; /* 100% divided by 8 slides */
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          padding: 60px 80px;
          box-sizing: border-box;
          position: relative;
          flex-shrink: 0;
        }

        /* Theme States */
        .slide-dark {
          background-color: #0f172a;
          color: #f8fafc;
        }

        /* Navigation Arrows Overlay Styles */
        .slide-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(15, 23, 42, 0.45);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.12);
          color: #ffffff;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 20;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .slide-arrow:hover {
          background: #2563eb;
          color: #ffffff;
          border-color: #2563eb;
          transform: translateY(-50%) scale(1.12);
        }

        .slide-arrow.arrow-left {
          left: 24px;
        }

        .slide-arrow.arrow-right {
          right: 24px;
        }

        /* Adjust hover color logic based on active slide theme context */
        .slide-dark-arrow-hover:hover {
          background: #38bdf8 !important;
          border-color: #38bdf8 !important;
          color: #0f172a !important;
        }

        /* Abstract Blurry Premium Backgrounds */
        .background-blob-rt {
          position: absolute;
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(37, 99, 235, 0.08) 0%, rgba(56, 189, 248, 0.01) 70%, transparent 100%);
          border-radius: 50%;
          top: -150px;
          right: -150px;
          z-index: 0;
          pointer-events: none;
        }

        /* Typography Styles */
        .slide-title {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 38px;
          font-weight: 700;
          letter-spacing: -0.02em;
          color: #0f172a;
          margin-bottom: 30px;
          border-left: 5px solid #2563eb;
          padding-left: 15px;
          line-height: 1.2;
          z-index: 1;
        }

        .slide-dark .slide-title {
          color: #ffffff;
          border-left-color: #38bdf8;
        }

        /* Hero Text Specific to Marquee View */
        .hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin-bottom: 50px;
          letter-spacing: -0.03em;
          background: linear-gradient(to right, #2563eb, #1d4ed8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-align: center;
        }

        /* The container mask hiding outer overflow elements */
        .marquee-container {
          width: 100%;
          overflow: hidden;
          position: relative;
          display: flex;
          mask-image: linear-gradient(to right, transparent, #000 10%, #000 90%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, #000 10%, #000 90%, transparent);
        }

        /* The inner running track holding both lists */
        .marquee-track {
          display: flex;
          gap: 30px;
          padding: 25px 0;
          width: max-content;
          animation: continuousScroll 25s linear infinite;
        }

        .marquee-container:hover .marquee-track {
          animation-play-state: paused;
        }

        /* Light-theme card adaptations */
        .service-card {
          width: 340px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          padding: 40px 30px;
          text-align: left;
          transition: all 0.3s ease;
          flex-shrink: 0;
          box-sizing: border-box;
        }

        .service-card:hover {
          transform: translateY(-8px);
          background: #ffffff;
          border-color: #2563eb;
          box-shadow: 0 20px 40px -15px rgba(37, 99, 235, 0.15);
        }

        .service-card h2 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 15px;
        }

        .service-card p {
          font-size: 0.95rem;
          line-height: 1.6;
          color: #475569;
        }

        /* Continuous Infinite Loop */
        @keyframes continuousScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(-50% - 15px)); }
        }

        /* ==========================================================================
           MEDIA QUERY SYSTEM FOR PREMIUM RESPONSIVENESS (MOBILE/TABLET DEEP-DIVE)
           ========================================================================== */
        @media (max-width: 1024px) {
          .slides-frame {
            height: auto !important;
            padding: 60px 20px;
          }
        }
      ` }} />

      {/* Your customized 980px tall slide container */}
      <div className="slides-frame">
        <div className="background-blob-rt"></div>
        <h1 className="hero-title">Our Services</h1>

        <div className="marquee-container">
          <div className="marquee-track">
            {/* Primary Original Set */}
            {servicesData.map((item, index) => (
              <div className="service-card" key={`orig-${index}`}>
                <h2>{item.title}</h2>
                <p>{item.desc}</p>
              </div>
            ))}

            {/* Identical Cloned Shadow Set for perfect infinite looping */}
            {servicesData.map((item, index) => (
              <div className="service-card" key={`clone-${index}`}>
                <h2>{item.title}</h2>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;